import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonPage, IonContent } from '@ionic/vue';
import { ref, Ref } from 'vue';
import Document from '@/interfaces/Document';
import ListOfDocuments from '@/components/DetailPage/DocumentPage/ListOfDocuments.vue'
import NewImage from '@/components/DetailPage/DocumentPage/NewImage.vue'
import ImageFullscreen from '@/components/DetailPage/DocumentPage/ImageFullscreen.vue' 


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentPage',
  setup(__props) {

const imageFullscreen: Ref<Document> = ref({} as Document)
const pointerEventWhenImageIsFullscreen: Ref<string> = ref("")

function setImageFullscreen(document?: Document) {
  if(document && Object.keys(imageFullscreen.value).length === 0 && document.path === document.signed_url) {
    setPointerEvent(true)
    imageFullscreen.value = document
  } else {
    setPointerEvent(false)
    imageFullscreen.value = {} as Document
  }
}

function setPointerEvent(value: boolean) {
  value ? pointerEventWhenImageIsFullscreen.value = "pointer-events-none hidden" : pointerEventWhenImageIsFullscreen.value = ""
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(NewImage, {
            class: _normalizeClass(pointerEventWhenImageIsFullscreen.value),
            onSetPointerEvent: _cache[0] || (_cache[0] = (value) => setPointerEvent(value))
          }, null, 8, ["class"]),
          _createVNode(ListOfDocuments, {
            class: _normalizeClass(pointerEventWhenImageIsFullscreen.value),
            onSetImageFullscreen: _cache[1] || (_cache[1] = (document) => setImageFullscreen(document))
          }, null, 8, ["class"]),
          _createVNode(ImageFullscreen, {
            imgFullscreen: imageFullscreen.value,
            onResetImgFullscreen: _cache[2] || (_cache[2] = ($event: any) => (setImageFullscreen()))
          }, null, 8, ["imgFullscreen"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})